export default {"theme":{"themes":{"light":{"primary":"#D36133","secondary":"#905DB4","negative":"#EB5757","accent":"#000000","error":"#ff1744"},"dark":{"primary":"#90caf9"}}}}
